module.exports = require("./te.js");